// extracted by mini-css-extract-plugin
module.exports = {"Chip":"Chip_Chip__2XKMf"};